<template>
<v-content >
  <v-btn
            v-scroll="onScroll"
            v-show="fab"
            fab
            dark
            fixed
            bottom
            right
            color="indigo"
            @click="toTop"
          >
            <v-icon>mdi-chevron-up-circle</v-icon>
          </v-btn>
      <v-container
       
        class="fill-height container mt-10"
        fluid
      >
          <v-row
          class="container"
        >
        <div class="container text-center" id="faqs">
          <h1 >
          OBIPETS FAQ’S 
            </h1>
        </div>
        
        <div class="question container">
        <h2>
        ¿Qué hago si encontré una mascota con la Placa Inteligente ObiPets?
        </h2>
        <p>
        Lo más probable es que la mascota esté extraviada, escanea el código 
        QR de la placa y podrás ver los datos de la mascota así como de su dueño.
        </p>
        </div>
        <div class="question container">
        <h2>
        ¿Cómo funciona la Placa Inteligente ObiPets?
        </h2>
        
        <p>
           Cada placa cuenta con un código QR único el cual al ser escaneado con el móvil mostrará información 
           de la mascota; el dueño de la mascota podrá saber la ubicación donde fue escaneada la placa. <br>
            Cada vez que la placa de tu mascota sea escaneada se te notificará automáticamente a través
             de un SMS, correo electrónico o WhatsApp, además de enviarte la geoposición utilizando el GPS 
             del dispositivo móvil que la escaneó.

        </p>
        </div>
         <div class="question container">
        <h2>
        ¿Qué información se muestra al escanear la placa?
        </h2>
        <p>
        Se muestra el nombre de la mascota, una foto, raza, cumpleaños, edad,
         género, especie, alergias, enfermedades, etc. Incluso si es sociable con otros animales.
          También se muestra la información del propietario.
        </p>
        </div>
        <div class="question container">
        <h2>
        ¿Qué pasa si se extravía mi mascota?
        </h2>
        <p>
        En caso de que tu mascota se extravíe, te recomendamos estar pendiente de los mensajes
         y llamadas que ingresen a tu número móvil, incluso de tu correo ya que alguna persona 
         puede escanear el código de tu placa y ponerse en contacto contigo.
        </p>
        </div>
        <div class="question container">
        <h2>
        ¿Puedo saber en dónde está mi mascota en cualquier momento?
        </h2>
        <p>
        La Placa Inteligente ObiPets no rastrea mascotas en tiempo real. 
        Cada vez que una persona escanea el código de la placa de tu mascota, 
        recibirás en tu móvil un SMS o correo electrónico con información y/o la ubicación de donde fue escaneada.
         De esta manera, la ubicación que recibirás será del GPS que esté escaneando la placa.
        </p>
        </div>
        <div class="question container">
        <h2>
        ¿Por qué no utilizar un dispositivo GPS en lugar de la Placa Inteligente ObiPets?
        </h2>
        <p>
        El costo de un GPS es aproximadamente de $ 3,500.00 a $ 5,000.00 pesos.
        Además, tendrás que utilizar un plan mensual de datos (chip móvil)
        <ul>
          <li>El dispositivo GPS necesita ser cargado periódicamente con la corriente eléctrica.</li>
          <li>El dispositivo GPS deberá ser hermético, en caso de que a tu mascota le guste mojarse.</li>
          <li> El costo y operación de un dispositivo GPS es mucho mayor, si te lo roban podrás perder toda tu inversión.</li>
        </ul>
        </p>
        </div>
        <div class="question container">
        <h2>
        ¿Tiene alguna restricción en cobertura?
        </h2>
        <p>
        No, la Placa Inteligente ObiPets puede ser escaneada en cualquier parte del mundo, utiliza la API de Google la cual facilita la incorporación y reconocimiento de cualquier ubicación.
        </p>
        </div>
        <div class="question container">
        <h2>
        ¿El servicio de tiene algún costo o mensualidad?
        </h2>
        <p>
        No, el servicio es gratuito y está incluido en la compra de tu placa.
        </p>
        </div>
        <div class="question container">
        <h2>
        ¿Quién puede acceder a mi información?
        </h2>
        <p>
        Los perfiles de las mascotas y tu perfil personal no están vinculados a 
        motores de búsqueda como Google, por lo cual, 
        si buscan tus datos no aparecerán, únicamente al escanear tu placa tendrán 
        acceso a tus datos de contacto.
        </p>
        </div>
        <div class="question container">
        <h2>
        ¿Qué pasa si cambio de número móvil, domicilio o datos de contacto?
        </h2>
        <p>
        Podrás utilizar la misma placa, sólo tendrías que ingresar a tu cuenta y actualizar la información.
        </p>
        </div>
        <div class="question container">
        <h2>
        ¿Cómo se envía la ubicación al dueño?
        </h2>
        <p>
        Al escanear el código QR, se abrirá un navegador web donde verás los datos de la
         mascota y del dueño, la página te solicitará acceso a tu ubicación. De esta manera 
         tu ubicación será enviada al dueño de la mascota.
        </p>
        </div>
        <div class="question container">
        <h2>
        ¿Cómo me notifican si la placa de mi mascota fue escaneada?
        </h2>
        <p>
        La información llegará a tu móvil por SMS, correo electrónico o mensaje de WhatsApp.
        </p>
        </div>
        <div class="question container">
        <h2>
        ¿Cómo se escanea el código?
        </h2>
        <p>
        Únicamente tendrás que abrir la cámara de tu móvil y apuntar hacia el código, al hacerlo la cámara lo enfocará y te mostrará información, ten en cuenta que:
        <ul>
          <li>Para facilitar la lectura, el lente de tu cámara debe estar limpio.</li>
          <li>Debes colocar el código de tal manera que se vea nítido en la pantalla de tu móvil.</li>
          <li>Todo el código debe aparecer en la imagen de tu cámara.</li>
          <li>No debes “tomar foto” al código, ya que así no funcionan.</li>
          <li>No usar flash al escanear el código.</li>
          <li>Tener la iluminación adecuada al escanear el código.</li>
        </ul>
        </p>
        </div>
        <div class="question container">
        <h2>
        ¿Con qué móvil se puede escanear la placa?
        </h2>
        <p>
        Las placas están diseñadas para ser escaneadas con la cámara de cualquier teléfono inteligente, puede ser Android o IOS.
        </p>
        </div>
        <div class="question container">
        <h2>
        ¿Qué pasa si mi cámara no abre la página al leer el código?
        </h2>
        <p>
        El código está diseñado para que pueda ser leído con cualquier teléfono inteligente y se abra en un navegador, sin embargo,
         existen teléfonos que al escanear el código abren una pestaña con el ícono de un link, puedes pulsar ese ícono y la página se abrirá en tu navegador.
        </p>
        </div>
        <div class="question container">
        <h2>
        ¿Recomiendan algún lector de códigos QR?
        </h2>
        <p>
        No es necesario, los códigos están diseñados para 
        leerse fácilmente con cualquier cámara de un teléfono inteligente.
        </p>
        </div>
        <div class="question container">
        <h2>
        ¿Qué pasa si mi placa se extravía, alguien podrá acceder a mi información?
        </h2>
        <p>
        En caso de que tu placa se extravíe, tu como dueño de la placa podrás acceder a tu cuenta de usuario y dar de baja la placa para que al ser escaneada no aparezca la información de tu mascota.
        </p>
        </div>
        <div class="question container">
        <h2>
        ¿Puedo tener más de una mascota asociada a mi cuenta?
        </h2>
        <p>
        Sí, puedes asociar las mascotas que quieras a tu cuenta.
        </p>
        </div>
        <div class="question container">
        <h2>
        ¿Puedo utilizar una placa con dos mascotas al mismo tiempo?
        </h2>
        <p>
        No, cada placa es única para una sola mascota, tendrías que tener una placa para cada una de tus mascotas.
        </p>
        </div>
        <div class="question container">
        <h2>
        ¿En caso de ya no tener a mi mascota, puedo volver a utilizar la misma placa para una mascota nueva?
        </h2>
        <p>
        Sí, puedes utilizar la misma placa, solo tendrías que actualizar la información con los datos de tu nueva mascota.
        </p>
        </div>
        <div class="question container">
        <h2>
        ¿Si mi mascota ya tiene un microchip, para qué necesito la placa?
        </h2>
        <p>
        Un microchip subcutáneo es una pequeña cápsula de cristal
        especial que tiene el tamaño de un grano de arroz el cual es colocado por un 
        médico veterinario debajo de la piel de la mascota y que al ser escaneado muestra un código numérico único 
        que permite la identificación de mascotas.
        </p>
        <ul>
          <li>El microchip NO es un GPS.</li>
          <li>El microchip NO es un rastreador de mascotas.</li>
          <li>El microchip NO es escaneable por cualquier persona, únicamente con un dispositivo compatible de un veterinario o dependencia gubernamental.</li>
          <li>La Placa Inteligente ObiPets puede ser escaneada por cualquier persona.</li>
          <li>La Placa Inteligente ObiPets no requiere de un dispositivo escáner especializado, únicamente con la cámara de tu móvil.</li>
          <li>La Placa Inteligente ObiPets puede indicar la geo posición instantánea de cuándo fue escaneado el código. </li>
        </ul>
        </div>
        <v-simple-table class="container">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-center"></th>
            <th class="text-center">Placa Inteligente ObiPets</th>
            <th class="text-center">Microchip</th>
            <th class="text-center">Placas Estandar</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in desserts" :key="item.name" class="text-center">
            <td>{{ item.name }}</td>
            <td>
              <v-icon
                  :color="item.colorOne"
                  small
                  class="mr-2"
                >
                {{ item.checkOne }}
                  
              </v-icon>
            </td>
            <td>
              <v-icon
                  :color="item.colorTow"
                  small
                  class="mr-2"
                >
                {{ item.checkTow }}
                  
              </v-icon>
            </td>
            <td>
              <v-icon
                  small
                  class="mr-2"
                  :color="item.colorThree"
                >
                {{ item.checkThree }}
                  
              </v-icon>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
        <div class="question container">
        <h2>
        ¿Qué tan precisa es la ubicación al ser escaneado el código?
        </h2>
        <p>
        Debido a que se utilizan satélites y triangulación espacial, la ubicación 
        puede dar una cercanía de metros en relación a la ubicación donde fue escaneada la placa.
        </p>
        </div>
        <div class="question container">
        <h2>
        ¿Tengo que crear un perfil cada que registre una mascota?
        </h2>
        <p>
        No es necesario, lo mejor es crear un solo perfil y posteriormente añadir las mascotas que quieras
        </p>
        </div>
        <div class="question container">
        <h2>
        ¿Una vez que recibí mi placa cómo la activo?
        </h2>
        <p>
        Si es tu primera placa tendrás que crear un usuario nuevo y cargar 
        la información de tu mascota así como la tuya, si ya cuentas con tu perfil únicamente tendrás que agregar una 
        mascota y posteriormente ingresar el código de activación de tu placa el cual viene en el empaque.
        </p>
        </div>
        <div class="question container">
        <h2>
        ¿Cómo elimino mi cuenta?
        </h2>
        <p>
        Desde tu perfil presiona la opción eliminar cuenta, te pedirá que confirmes ingresando tu contraseña y 
        listo la cuenta se elimina de inmediato.
        </p>
        </div>
        <div class="question container">
        <h2>
        ¿De qué material es la placa?
        </h2>
        <p>
        La placa esta fabricada con aluminio, el mismo material que usan las placas veterinarias.
        </p>
        </div>
        <div class="question container">
        <h2>
        ¿El material es perjudicial para mi mascota?
        </h2>
        <p>
        No, el material no es perjudicial ya que es de uso común, además son resistentes y 
        están fabricadas para que no se borre la información con facilidad.
        </p>
        </div>
        <div class="question container">
        <h2>
        ¿Las placas se pueden mojar?
        </h2>
        <p>
        Sí, así que no tengas miedo de que tu mascota le guste jugar con agua.
        </p>
        </div>
        <div class="question container">
        <h2>
        ¿Cuánto miden las placas?
        </h2>
        <p>
        La placa tiene un diámetro de 3 cm.
        </p>
        </div>
        <div class="question container">
        <h2>
        ¿Sirven para todo tipo de mascotas?
        </h2>
        <p>
        Sí, sirven para todo tipo de mascotas, principalmente diseñadas para perros y gatos.
        </p>
        </div>
        <div class="question container">
        <h2>
        ¿Dónde puedo adquirir las placas?
        </h2>
        <p>
        Podrás comprarlas en nuestra <a href="https://obipets.myshopify.com/products/placa-obipets">tienda virtual</a> y posteriormente en tiendas veterinarias.
        </p>
        </div>
          </v-row>
    </v-container>
</v-content>     
</template>

<script>
export default {
  data() {
    return {
      fab: false,
      desserts: [
        {
          name: "Muestra la ubicación de donde fue escaneada la placa",
          checkOne: "mdi-check-all",
          checkTow: "mdi-close",
          checkThree: "mdi-close",
          colorOne: "green",
          colorTow: "red",
          colorThree: "red",
        },
        {
          name: "Visibilidad",
          checkOne: "mdi-check-all",
          checkTow: "mdi-close",
          checkThree: "mdi-check-all",
          colorOne: "green",
          colorTow: "red",
          colorThree: "green",
        },
        {
          name: "Acceso inmediato a información de la mascota",
          checkOne: "mdi-check-all",
          checkTow: "mdi-close",
          checkThree: "mdi-check-all",
          colorOne: "green",
          colorTow: "red",
          colorThree: "green",
        },
        {
          name: "Acceso inmediato a información de contacto",
          checkOne: "mdi-check-all",
          checkTow: "mdi-close",
          checkThree: "mdi-check-all",
          colorOne: "green",
          colorTow: "red",
          colorThree: "green",
        },
        {
          name: "Posibilidad de actualizar la información",
          checkOne: "mdi-check-all",
          checkTow: "mdi-check-all",
          checkThree: "mdi-close",
          colorOne: "green",
          colorTow: "green",
          colorThree: "red",
        },
        {
          name: "Proporciona métodos de contacto alternativos",
          checkOne: "mdi-check-all",
          checkTow: "mdi-check-all",
          checkThree: "mdi-close",
          colorOne: "green",
          colorTow: "green",
          colorThree: "red",
        },
        {
          name: "Muestra información médica o importante",
          checkOne: "mdi-check-all",
          checkTow: "mdi-close",
          checkThree: "mdi-close",
          colorOne: "green",
          colorTow: "red",
          colorThree: "red",
        },
        {
          name: "Perfil online de la mascota",
          checkOne: "mdi-check-all",
          checkTow: "mdi-close",
          checkThree: "mdi-close",
          colorOne: "green",
          colorTow: "red",
          colorThree: "red",
        },
        {
          name:
            "Envía notificaciones al propietario cuando alguien accede a la información",
          checkOne: "mdi-check-all",
          checkTow: "mdi-close",
          checkThree: "mdi-close",
          colorOne: "green",
          colorTow: "red",
          colorThree: "red",
        },
        {
          name: "Acceso internacional a la información",
          checkOne: "mdi-check-all",
          checkTow: "mdi-close",
          checkThree: "mdi-check-all",
          colorOne: "green",
          colorTow: "red",
          colorThree: "green",
        },
        {
          name: "Precio menor a $ 1,000.00 pesos",
          checkOne: "mdi-check-all",
          checkTow: "mdi-close",
          checkThree: "mdi-check-all",
          colorOne: "green",
          colorTow: "red",
          colorThree: "green",
        },
      ],
    };
  },
  methods: {
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
  },
};
</script>

